import { GeneralHttpResponse } from "../types/genericTypes";
import axios from "axios";
import env from "react-dotenv";

//Catálogo tipo producto
export const getKardexHttp = async () => {
  try {
    const response = await axios.get(`${env.API_URL}/getKardex`);
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
